import Lottie from 'lottie-react';
import serverConnection from '../jsons/server-connection.json';

const ServerConnection = props => {
  return <Lottie animationData={serverConnection} {...props} />;
};

export default ServerConnection;
